<script lang="ts">
    import { getContext } from "svelte";
    import { Table } from "sveltestrap";
    import type { GetAnswerFn, QuestionGrid, SaveAnswerFn } from "../../global";
    import type { Answer } from "../../Model/Answer";
    import type { Question } from "../../Model/Question";
    import { debounce } from "../../Services";
    import QuestionBox from "./QuestionBox.svelte";
    import QuestionGridInput from "./QuestionGridInput.svelte";
    import QuestionHeader from "./QuestionHeader.svelte";
    import QuestionHeaderGrid from "./QuestionHeaderGrid.svelte";
    import AlertSaveError from "../AlertSaveError.svelte";

    export let question: Question;

    const saveDebounce = debounce(500);
    const getAnswer: GetAnswerFn = getContext('getAnswer');
    const saveAnswer: SaveAnswerFn = getContext('saveAnswer');

    let isSaving = false;
    let saveError = false;
    let grid: QuestionGrid;
    let answer: Answer;

    $: setupQuestion(question);

    function setupQuestion(question: Question): void {
        grid = question.options.questionGrid;
        answer = getAnswer(question.id);

        if (!Array.isArray(answer.value)) {
            answer.value = [];
        }
    }

    function onSaverequest(): void {
        saveDebounce(saveAnswerWrapper);
    }

    async function saveAnswerWrapper(): Promise<void> {
        try {
            isSaving = true;
            await saveAnswer(answer);
            saveError = false;
        } catch (error) {
            saveError = true;
        } finally {
            isSaving = false;
        }
    }

</script>

<style lang="scss">

    .column-name {
        font-weight: 500;
        font-size: 0.9rem;
    }

</style>


<QuestionHeader {question} />

{#each grid.rows as row}
    <div class="mt-4">
        <div><strong>{row.text}</strong></div>
        <Table>
            <tbody>
                {#each grid.columns as column}
                <tr>
                    <td>
                        <span class="column-name">{column.name}</span>
                    </td>
                    <td>
                        <QuestionGridInput {column} {row} {answer} on:saverequest={onSaverequest} />
                    </td>
                </tr>
                {/each}
            </tbody>
            {#if saveError}
                <AlertSaveError />
            {/if}
        </Table>
    </div>
{/each}
